interface Video {
  hashedId(): string;
  name(): string;
  bind(event: string, handler: () => void): void;
}

export function initVideoTracking() {
  window._wq = window._wq || [];
  window._wq.push({
    id: '_all',
    onReady: (video: Video) => {
      let played = false;
      video.bind('play', () => {
        if (!played) {
          played = true;
          logVideoPlay(video);
        }
      });
    },
  });
}

function logVideoPlay(video: Video) {
  const videoId = video.hashedId();
  const videoTitle = video.name();

  // This POST is caught by our CloudFlare worker, which identifies the viewer
  // and fires off a webhook to Zapier.
  fetch('/api/video-tracking', {
    body: JSON.stringify({ videoId, videoTitle }),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
